import { Divider } from '@cleartrip/ct-design-components'
import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import LayoverAirport from './layoverAirport'

const selectedCount = (layoverAirport: any) =>
  Object.values(layoverAirport?.selectedOptions || {}).reduce(
    (total: number, airports: any) => total + (Array.isArray(airports) ? airports.length : 0),
    0
  )

const LayoverAirportFilterNew = ({
  onFilterChange,
  layoverAirport,
  returnLayoverAirport,
  isRT,
  processedData,
  clearFiltersCategoryWise,
  selectedFilters,
  isRevamp = false,
}: {
  onFilterChange: (type: any, value: any, index?: number, legKey?: 'onwardLeg' | 'returnLeg') => void
  layoverAirport: any
  returnLayoverAirport: any
  isRT: boolean
  processedData: any
  clearFiltersCategoryWise: any
  selectedFilters: any
  isRevamp?: boolean
}) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'layoverAirport')
  const showBothLegs = isRT && !isEmpty(returnLayoverAirport?.availableLayoverAirport)
  const count = selectedCount(layoverAirport) + selectedCount(returnLayoverAirport)

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Layover airport' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(layoverAirport?.availableLayoverAirport) && (
          <LayoverAirport
            onFilterChange={onFilterChange}
            layoverAirport={layoverAirport}
            from={processedData?.source}
            to={processedData?.destination}
            isRT={isRT}
            isRevamp={isRevamp}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />
        {!isRevamp && showBothLegs && <Divider className='w-100p my-2' borderColor='#E6E6E6' />}

        {showBothLegs && (
          <LayoverAirport
            onFilterChange={(type: any, value: any) => onFilterChange(type, value, 0, 'returnLeg')}
            layoverAirport={returnLayoverAirport}
            from={processedData?.destination}
            to={processedData?.source}
            isRT={isRT}
            isRevamp={isRevamp}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default LayoverAirportFilterNew
